import axios from 'axios'
import { get, set } from 'lodash'
import * as utils from '../util/table.util'

const ROOT = process.env.REACT_APP_AUGMENTT_API_URL

export const REPORTS_URL = (reportId) => `${ROOT}/report/${reportId}`
export const REPORT_EXPORT_URL = `${ROOT}/report`
export const REPORT_SIGNEDURL_URL = `${ROOT}/report/signed-url`

export function fetchReportData(reportId) {
  return axios.get(REPORTS_URL(reportId))
}

export function updateReport(reportId) {
  return axios.put(REPORTS_URL(reportId))
}

export function removeReport(reportId) {
  return axios.delete(REPORTS_URL(reportId))
}

export const createSignedUrl = async ({ customer, reportType, reportName, reportPayload, sort }) => {
  const {
    data: { report, signedUrl },
  } = await axios.post(REPORT_SIGNEDURL_URL, {
    customerId: customer,
    reportType,
    reportName,
  })

  if (sort) {
    const { field, func, key, order } = sort
    const comparator = (a, b) => {
      if (typeof b === 'string') {
        return b.localeCompare(a)
      }

      if (a > b) {
        return -1
      }

      return a < b ? 1 : 0
    }

    const data = get(reportPayload, key)
    const sortedData = data.sort(
      func
        ? (a, b) => utils[func](a, b, order, field, a, b)
        : (a, b) => {
            const valueA = get(a, field) ?? ''
            const valueB = get(b, field) ?? ''

            return order === 'desc' ? comparator(valueA, valueB) : comparator(valueB, valueA)
          },
    )

    set(reportPayload, key, sortedData)
  }

  await axios.put(signedUrl, reportPayload)

  return report
}

export const createReport = async ({
  customer,
  dateRange,
  fileExtension = 'pdf',
  reportName,
  reportType,
  reportPayload,
  savedSelectedLicenses,
  sort,
  filters,
}) =>
  axios.post(REPORT_EXPORT_URL, {
    customer,
    fileExtension,
    filters,
    reportName,
    reportType,
    savedSelectedLicenses,
    sorts: sort,
    reportId:
      reportPayload &&
      (
        await createSignedUrl({
          customer,
          reportType,
          reportName,
          sort,
          reportPayload: { ...reportPayload, ...dateRange },
        })
      ).id,
    ...dateRange,
  })

// Force download of file onto users computer from URL
export const onDownloadFileClick = async (location, fileName, fileExtension = 'pdf', callback = () => {}) => {
  fetch(location, { method: 'GET' })
    .then((response) => response.blob())
    .then((blob) => {
      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([blob]))
      // Create link element
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${fileName}.${fileExtension}`)
      // Append to html link element page
      document.body.appendChild(link)
      // Start download
      link.click()
      // Clean up and remove the link
      link.parentNode.removeChild(link)
      // Call callback function if provided
      callback()
    })
    // Call callback function if provided for error
    .catch(callback)
}
